/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { Card, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import { Tooltip } from 'react-tooltip'
import MDTypography from 'components/MDTypography';
import React, { useEffect, useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { loadingAction } from 'ReduxReducers/loadingReducer';
import LoginLayout from 'layouts/loginLayout/loginLayout';
import { useDispatch } from 'react-redux';
import { userResetPassword } from 'utils/authApi';
import { getSesstionDataByUserID, showResMsg } from 'utils/generic';
import { genericMessage } from 'utils/genericMessages';
const errMsg = {
  color: `red`,
  fontSize: `11px`
};

let FORGOT_PASS_USER_DETAILS;

function ChangePass({ ...props }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [passwordErr, setPasswordErr] = useState(false);
  const [confirmPasswordTitleErr, setConfirmPasswordTitleErr] = useState("");
  const [passwordTitleErr, setPasswordTitleErr] = useState("");
  const [currentPasswordErr, setCurrentPasswordErr] = useState(false);
  const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [routePath, setRoutePath] = useState(false);

  const [values, setValues] = React.useState({
    emailAddress: '',
    confirmPassword: '',
    password: '',
    _id: ''
  });
  const handleChange = name => event => {
    console.log('value', event.target.value);
    setValues({ ...values, [name]: event.target.value });
  };

  if (sessionStorage.getItem('LOGIN_EMAIL') != undefined || sessionStorage.getItem('LOGIN_EMAIL') != null)
    values.emailAddress = sessionStorage.getItem('LOGIN_EMAIL').replaceAll('"', '');
  if (sessionStorage.getItem('USER_ID') != undefined || sessionStorage.getItem('USER_ID') != null)
    values._id = sessionStorage.getItem('USER_ID').replaceAll('"', '');

  if (sessionStorage.getItem('FORGOT_PASS_USER_DETAILS') !== undefined && sessionStorage.getItem('FORGOT_PASS_USER_DETAILS') !== null) {
    FORGOT_PASS_USER_DETAILS = JSON.parse(sessionStorage.getItem('FORGOT_PASS_USER_DETAILS'));
    values.emailAddress = FORGOT_PASS_USER_DETAILS.emailAddress;
    values._id = FORGOT_PASS_USER_DETAILS._id;
  }
  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') !== null) {
    FORGOT_PASS_USER_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.emailAddress = FORGOT_PASS_USER_DETAILS.emailAddress;
    values._id = FORGOT_PASS_USER_DETAILS._id;
    values.userType = FORGOT_PASS_USER_DETAILS?.userType;

  }


  useEffect(() => {
    dispatch(loadingAction(false))
  }, [dispatch])
  let mandateFlag = false;
  const changePassword = async () => {
    try {
      if (values.password.toString().trim() === "") {
        setPasswordErr(true);
        setPasswordTitleErr("New Password can't be blank")
        mandateFlag = true;
      }
      // else if (values.password.toString().trim().length < 8) {
      //     setPasswordErr(true);
      //     setPasswordTitleErr("New Password should contain atleast 8 characters")
      //     mandateFlag = true;
      // } 
      else if (values.password.toString().trim().length < 8 || values.password.toString().trim().length > 20) {
        setPasswordErr(true);
        setPasswordTitleErr("Password should be between 8 to 20 characters");
        mandateFlag = true;
      } else if (!/[A-Z]/.test(values.password)) {
        setPasswordErr(true);
        setPasswordTitleErr("Password should contain at least one uppercase letter");
        mandateFlag = true;
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.password)) {
        setPasswordErr(true);
        setPasswordTitleErr("Password should contain at least one special character");
        mandateFlag = true;
      }
      else {
        setPasswordErr(false);
      }
      if (values.confirmPassword.toString().trim() === "") {
        setConfirmPasswordErr(true);
        setConfirmPasswordTitleErr("Confirm Password can't be blank")
        mandateFlag = true;
      }
      // else if (values.confirmPassword.toString().trim().length < 8) {
      //   setConfirmPasswordErr(true);
      //   setConfirmPasswordTitleErr("Confirm Password should be at least 8 characters")
      //   mandateFlag = true;
      // }  
      else if (values.confirmPassword.toString().trim().length < 8 || values.confirmPassword.toString().trim().length > 20) {
        setConfirmPasswordErr(true);
        setConfirmPasswordTitleErr("Password should be between 8 to 20 characters");
        mandateFlag = true;
      } else if (!/[A-Z]/.test(values.confirmPassword)) {
        setConfirmPasswordErr(true);
        setConfirmPasswordTitleErr("Password should contain at least one uppercase letter");
        mandateFlag = true;
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.confirmPassword)) {
        setConfirmPasswordErr(true);
        setConfirmPasswordTitleErr("Password should contain at least one special character");
        mandateFlag = true;
      } else {
        setConfirmPasswordErr(false);
      };
      if (mandateFlag) {
        return;
      }
      if (values.password.toString().trim() !== values.confirmPassword.toString().trim()) {
        showResMsg(genericMessage.samePassword, 1000, false)
      }
      else {
        userResetPassword(values, async (data) => {
          showResMsg(data.Result_Status ? genericMessage.passwordUpdate : data.Result_Message, 1000, data.Result_Status);
          if (data.Result_Status) {
            await getSesstionDataByUserID(data.Result_Output._id);
            sessionStorage.removeItem('FORGOT_PASS_USER_DETAILS');
            setTimeout(() => {
              window.location.href = values.userType === "Warehouse" ? "/warehouseDashboard" : values.userType === "Business" ? "/dashboard" : "dashboard-su"
            }, 1000);

          } else {
            dispatch(loadingAction(false))
          }

        }, dispatch)
      }

    } catch (error) {
      console.log("Catch in changePassword:", error);
    }
  }

  const conditions = [
    {
      test: values.password.trim().length > 8 && values.password.trim().length < 20,
      message: "Field length should be between 8 to 20",
    },
    {
      test: /[A-Z]/.test(values.password),
      message: "Atleast 1 Upper case ",
    },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/.test(values.password),
      message: "Atleast 1 special character",
    },
  ];
  const conditions2 = [
    {
      test: values.confirmPassword.trim().length > 8 && values.confirmPassword.trim().length < 20,
      message: "Field length should be between 8 to 20",
    },
    {
      test: /[A-Z]/.test(values.confirmPassword),
      message: "Atleast 1 Upper case ",
    },
    {
      test: /[!@#$%^&*(),.?":{}|<>]/.test(values.confirmPassword),
      message: "Atleast 1 special character",
    },
  ];

  return (
    <LoginLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Invoice & Recover
          </MDTypography>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Change Password
          </MDTypography>
        </MDBox>
        <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
          <Grid item xs={8} lg={8}>
            <MDInput
              type="text"
              label="Email Address"
              variant="outlined"
              fullWidth
              value={values.emailAddress}
              // onChange={handleChange("emailAddress")}
              disabled
            />
          </Grid>


          <Grid item xs={8} lg={8}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
              <OutlinedInput
                variant="outlined"
                type={showNewPassword ? "text" : "password"}
                autoComplete='new-password'
                inputProps={{
                  maxLength: 30
                }}
                value={values.password}
                onChange={handleChange("password")}
                onKeyUp={(e) => {
                  if (e.key === "Enter") changePassword();
                }}
                data-tooltip-id="passwordTooltip1"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      edge="end"
                    >
                      {showNewPassword ? (
                        <VisibilityOff onClick={() => setShowNewPassword(!showNewPassword)} />
                      ) : (
                        <Visibility onClick={() => setShowNewPassword(!showNewPassword)} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="New Password"
              />
              <Tooltip id="passwordTooltip1" place="left" effect="float" border="1px solid #49a3f1" style={{ backgroundColor: 'white', color: 'black', margin: '0px -20px', borderRadius: '5px', }}>
                <ol style={{ listStyleType: 'none', padding: 0, margin: 0, fontSize: "12px" }}>
                  {conditions.map((condition, index) => (
                    <li key={index} style={{ color: condition.test ? 'green' : 'gray' }}>
                      {condition.message}
                    </li>
                  ))}
                </ol>
              </Tooltip>
              {/* {passwordErr !== "" ? <span style={errMsg}>{passwordTitleErr}</span> : ""} */}
            </FormControl>
            {passwordErr ? <span style={errMsg}>{passwordTitleErr}</span> : ""}
          </Grid>
          <Grid item xs={8} lg={8}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={showConfirmPassword ? "text" : "password"}
                value={values.confirmPassword}
                onChange={handleChange("confirmPassword")}
                variant="outlined"
                onKeyUp={(e) => {
                  if (e.key === "Enter") changePassword();
                }}
                data-tooltip-id="passwordTooltip"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onChange={handleChange("confirmPassword")}
                      // onMouseDown={setShowNewPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        />
                      ) : (
                        <Visibility onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                label="Confirm Password"
              />
              <Tooltip id="passwordTooltip" place="left" effect="float" border="1px solid #49a3f1" style={{ backgroundColor: 'white', color: 'black', margin: '0px -20px', borderRadius: '5px', }}>
                <ol style={{ listStyleType: 'none', padding: 0, margin: 0, fontSize: "12px" }}>
                  {conditions2.map((condition, index) => (
                    <li key={index} style={{ color: condition.test ? 'green' : 'gray' }}>
                      {condition.message}
                    </li>
                  ))}
                </ol>
              </Tooltip>
              {/* {confirmPasswordErr !== "" ? <span style={errMsg}>{passwordTitleErr}</span> : ""} */}
            </FormControl>
            {confirmPasswordErr ? <span style={errMsg}>{confirmPasswordTitleErr}</span> : ""}
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          pb={3}
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={2.288}>

            <Link to={"/login"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"

                fullWidth
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={2.288}>
            <MDButton
              onClick={changePassword}
              rel="noreferrer"
              variant="gradient"
              color="success"
              fullWidth
            >
              Save
            </MDButton>
          </Grid>
        </Grid>
      </Card>
    </LoginLayout>
  );
}

export default ChangePass;
